import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import ShareButton from '../components/ShareButton';

const Courses = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await api.get('/courses');
      setCourses(response.data);
    } catch (error) {
      console.error('Failed to fetch courses:', error);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 px-6" data-testid="courses-page">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight mb-4" data-testid="courses-title">
            Digital Courses
          </h1>
          <p className="text-muted-foreground text-lg">
            Learn new skills with our comprehensive courses
          </p>
        </div>

        {courses.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="courses-grid">
            {courses.map((course) => (
              <div
                key={course.id}
                className="product-card p-6 relative"
                data-testid={`course-card-${course.id}`}
              >
                {/* Share Button */}
                <div className="absolute top-4 right-4 z-10">
                  <ShareButton
                    type="service"
                    itemId={course.id}
                    itemName={course.name}
                  />
                </div>
                
                <Link to={`/courses/${course.id}`}>
                  {course.thumbnail && (
                    <div className="aspect-video rounded-lg overflow-hidden mb-4">
                      <img
                        src={course.thumbnail}
                        alt={course.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  <h3 className="text-xl font-semibold mb-2">{course.name}</h3>
                  <p className="text-muted-foreground text-sm mb-4 line-clamp-2">
                    {course.description}
                  </p>
                  {course.modules && course.modules.length > 0 && (
                    <p className="text-sm text-accent mb-4">
                      {course.modules.length} Modules
                    </p>
                  )}
                  <div className="flex items-center gap-3">
                    {course.original_price && (
                      <span className="text-muted-foreground line-through text-sm">
                        ₹{course.original_price}
                      </span>
                    )}
                    <span className="text-2xl font-bold text-primary">
                      ₹{course.price}
                    </span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16" data-testid="no-courses">
            <p className="text-muted-foreground text-lg">No courses available yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Courses;
